import React from 'react';
import { Pencil, Key, Ban, Trash2, MoreVertical } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../../components/ui/custom-dropdown-menu';
import type { PlatformUser } from '../../types/user';
interface UserActionsMenuProps {
  user: PlatformUser;
  currentUser: PlatformUser;
  onEdit: (user: PlatformUser) => void;
  onResetPassword: (user: PlatformUser) => void;
  onDisableUser: (user: PlatformUser) => void;
  onDelete: (user: PlatformUser) => void;
  deleteUserLoading?: boolean;
  resetPasswordLoading?: boolean;
  toggleTwoFactorLoading?: boolean;
}

export const UserActionsMenu: React.FC<UserActionsMenuProps> = ({
  user,
  currentUser,
  onEdit,
  onResetPassword,
  onDisableUser,
  onDelete,
  deleteUserLoading = false,
  resetPasswordLoading = false,
  toggleTwoFactorLoading = false,
}) => {
  const isDisabled = user.status === 'inactive';
  const isSelf = user.id === currentUser.id;
  const isLoading = deleteUserLoading || resetPasswordLoading || toggleTwoFactorLoading;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-page-bg transition-colors">
        <MoreVertical className="h-4 w-4" />
        <span className="sr-only">Open menu</span>
      </DropdownMenuTrigger>      <DropdownMenuContent align="end">
        {!isSelf && !isLoading && (
          <DropdownMenuItem
            onClick={() => onEdit(user)}
            className="cursor-pointer"
          >
            <Pencil className="mr-2 h-4 w-4" />
            Edit
          </DropdownMenuItem>
        )}
        {!isSelf && !isLoading && (
          <DropdownMenuItem
            onClick={() => onResetPassword(user)}
            className="cursor-pointer"
          >
            <Key className="mr-2 h-4 w-4" />
            Reset Password
          </DropdownMenuItem>
        )}
        {!isSelf && !isLoading && (
          <DropdownMenuItem
            onClick={() => onDisableUser(user)}
            className="cursor-pointer"
          >
            <Ban className="mr-2 h-4 w-4" />
            {isDisabled ? 'Enable' : 'Disable'} User
          </DropdownMenuItem>
        )}
        {!isSelf && !isLoading && (
          <DropdownMenuItem
            onClick={() => onDelete(user)}
            className="cursor-pointer text-red-600"
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </DropdownMenuItem>
        )}
        {isLoading && (
          <DropdownMenuItem className="cursor-not-allowed opacity-50">
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900 mr-2"></div>
              Processing...
            </div>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}; 